import { create } from "zustand";

export interface LoadingStoreType {
  show: boolean;
  message: string;
  setShow: (show: boolean) => void;
}

export const useLoadingStore = create<LoadingStoreType>(
  (set) => ({
    show: false,
    message: '',
    setShow: (show: boolean) => set({ show }),
  }),
);
